import { hasRequiredFields } from '.';
import { requiredJobFields } from '../../constants';

const csv = require('csvtojson');

export const validateCSVUpload = csvUpload => {
  return new Promise((resolve, _reject) => {
    const headers = csvUpload.split(/\r\n|\n/)[0].split(',');
    const missingHeaders = [];
    requiredJobFields.map(r => (headers.includes(r) ? null : missingHeaders.push(r)));
    const jobs = [];
    csv({
      noheader: false,
      headers,
    })
      .fromString(csvUpload)
      .then(jsonArray => {
        jobs.push(...jsonArray);
        return jobs;
      })
      .then(result => {
        const response = hasRequiredFields(result);
        if (missingHeaders.length) {
          resolve({ missing: [], missingFields: missingHeaders });
        } else if (response.missing) {
          resolve({ missing: response.missing, missingFields: [] });
        } else {
          resolve(response.jobs);
        }
      });
  });
};
